import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { reverse, sort, propEq, contains } from 'ramda';

import {
  getLocations,
  getSortedSelectedWithDataIds,
  getLocationsWithMultipleDataIds,
} from '../../selectors/locations';
import { getMetric } from '../../selectors/options';
import { getCrimes, getHighlightTimestamps } from '../../selectors/crimes';
import { isPresent } from '../../utils/helpers';
import { sortIntervals } from '../../utils/time';
import { MetricProp } from '../../constants';
import DeltaBarChart from './DeltaBarChart';
import { setYFromValues } from '../RecurringChartContainer';

const getData = createSelector(
  getSortedSelectedWithDataIds,
  getLocationsWithMultipleDataIds,
  getMetric,
  getLocations,
  getCrimes,
  (ids, multipleIds, metric, cities, crimes) => {
    const valueField = MetricProp[metric];

    return setYFromValues(
      reverse(
        ids.filter(id => contains(id, multipleIds)).map(id => {
          const [first, second] = sort(sortIntervals, crimes[id]);

          if (!isPresent(first) || !isPresent(second)) return null;
          const city = cities.find(propEq('id', id));
          return {
            id,
            city: city.name,
            state: city.state,
            value: second[valueField] - first[valueField],
          };
        }),
      ),
    );
  },
);

export default connect(state => ({
  data: getData(state),
  highlightTimespans: getHighlightTimestamps(state),
}))(DeltaBarChart);



// WEBPACK FOOTER //
// ./src/components/DeltaBarChart/DeltaBarChartContainer.jsx